import React, { type CSSProperties } from 'react';
import { type LayoutName } from '@wix/communities-blog-client-common';
import type { PostAction } from '../../constants/post-actions';
import { useFeedMetadataSettings } from '../../hooks/use-feed-metadata-settings';
import { type LayoutItemConfig } from '../../services/layout-config';
import { type NormalizedPost } from '../../types';
import { PostListItemProGalleryCategoryLabel } from './post-list-item-pro-gallery-category-label';
import { PostListItemProGalleryHeader } from './post-list-item-pro-gallery-header';
import { PostListItemProGalleryTitleDescription } from './post-list-item-pro-gallery-title-description';
import s from './post-list-item-pro-gallery-header-title-container.scss';

type Props = {
  post: NormalizedPost;
  showMoreButton: boolean;
  layoutList: boolean;
  type: LayoutName | undefined;
  styleFontSizeMetadata: CSSProperties;
  visibleActions: PostAction[] | undefined;
  withoutFooter: boolean;
  itemConfig: Partial<LayoutItemConfig>;
};

export const PostListItemProGalleryHeaderTitleContainer = ({
  post,
  showMoreButton,
  layoutList,
  type,
  styleFontSizeMetadata,
  visibleActions,
  withoutFooter,
  itemConfig,
}: Props) => {
  const feedMetadataSettings = useFeedMetadataSettings({ post });
  const hasIconsInHeader = showMoreButton || post?.isPinned;

  return (
    <div className={!layoutList ? s.container : undefined}>
      <PostListItemProGalleryTitleDescription
        type={type}
        post={post}
        itemConfig={itemConfig}
        showMoreButton={showMoreButton}
        withoutFooter={withoutFooter}
      />
      {!layoutList ? (
        <>
          <PostListItemProGalleryCategoryLabel post={post} type={type} />
          {(hasIconsInHeader || feedMetadataSettings.isMetadataHeaderVisible) && (
            <PostListItemProGalleryHeader
              post={post}
              type={type}
              styleFontSizeMetadata={styleFontSizeMetadata}
              showMoreButton={showMoreButton}
              visibleActions={visibleActions}
            />
          )}
        </>
      ) : null}
    </div>
  );
};
